import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, map, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  private geocoder = new google.maps.Geocoder();
  private placesService = new google.maps.places.PlacesService(document.createElement('div'));

  constructor(private http: HttpClient, private authService: AuthService) { }

  url = environment.products_url;
  swaggerUrl = "https://func-europe-identity-development.azurewebsites.net/api/";

  private getAuthHeaders(): Observable<HttpHeaders> {
    return from(this.authService.getAccessToken()).pipe(
      map((token) => {
        if (!token) {
          throw new Error('Failed to acquire token');
        }
        return new HttpHeaders({
          Authorization: `Bearer ${token}`,
        });
      })
    );
  }

  // Obtener latitud y longitud de una dirección
  getLatLongFromAddress(address: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ 'address': address }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
        } else {
          reject('Geocode was not successful for the following reason: ' + status);
        }
      });
    });
  }

  // Obtener dirección a partir de latitud y longitud
  getAddressFromLatLong(lat: number, lng: number): Promise<any> {
    const latLng = new google.maps.LatLng(lat, lng);
    return new Promise((resolve, reject) => {
      this.geocoder.geocode({ 'location': latLng }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK) {
          resolve(results[0].formatted_address);
        } else {
          reject('Reverse geocode was not successful for the following reason: ' + status);
        }
      });
    });
  }

  // Autocompletar direcciones
  getAutocompletePredictions(input: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      autocompleteService.getPlacePredictions({ input }, (predictions: any, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(predictions);
        } else {
          reject('Autocomplete was not successful for the following reason: ' + status);
        }
      });
    });
  }

  getDistance(originLatitude: number | null | undefined, originLongitude: number | null | undefined, destinationLatitude: number | null | undefined, destinationLongitude: number | null | undefined) {
    return this.getAuthHeaders().pipe(
      switchMap((headers) =>
        this.http.get<any>(`${this.url}/route-information?originLatitude=${originLatitude}&originLongitude=${originLongitude}&destinationLatitude=${destinationLatitude}&destinationLongitude=${destinationLongitude}`, {
          headers,
        })
      )
    );
  }

  getPlaceDetails(placeId: string): Promise<google.maps.places.PlaceResult> {
    const service = new google.maps.places.PlacesService(document.createElement('div'));

    return new Promise((resolve, reject) => {
      service.getDetails({ placeId }, (place, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && place) {
          resolve(place);
        } else {
          reject(`Place details request failed with status: ${status}`);
        }
      });
    });
  }

}
